<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Dance Events</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm dance-city-dance section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Dance City <span> Dance</span></h2>
        </div>
        <div class="row">
            <div class="col-md-4 ">
                <div class="grid cs-style-1">
                    <!-- <h4>Dance Nagpur Dance</h4> -->
                    <figure>
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dance_nag_1.webp"
                            alt="img01">
                        <figcaption>
                            <h3>Dance Nagpur Dance</h3>
                            <a href="https://plus.google.com/photos/101160450154881543915/albums/5892949226402684753?banner=pwa&partnerid=gplp0"
                                target="_blank">Click to more</a>
                        </figcaption>
                    </figure>
                </div>
            </div>
            <div class="col-md-4">
                <div class="grid cs-style-1">
                    <!-- <h4>Flash Mob</h4> -->
                    <figure>
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/flash_mob_7.webp"
                            alt="img01">
                        <figcaption>
                            <h3>Flash Mob</h3>
                            <a href="flash-mob" target="_blank">Click to more</a>
                        </figcaption>
                    </figure>
                </div>
            </div>

            <div class="col-md-4">
                <div class="grid cs-style-1">
                    <!-- <h4>Workshop</h4> -->
                    <figure>
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/harshita-gautam.jpg"
                            alt="img01">
                        <figcaption>
                            <h3>Harshita Gautam</h3>
                            <a routerLink="/harshita-gautam">Click to more</a>
                        </figcaption>
                    </figure>
                </div>
            </div>


        </div>


    </div>
</section>
